import { Box } from '@mui/material';
import AvailabilityWidget from '@src/App/Components/_UnderConstruction/Widgets/AvailabilityWidget';
import CertificatesWidget from '@src/App/Components/_UnderConstruction/Widgets/CertificatesWidget';
import EmployeeTalksWidget from '@src/App/Components/_UnderConstruction/Widgets/EmployeeTalksWidget';
import GoalsWidget from '@src/App/Components/_UnderConstruction/Widgets/GoalsWidget';
import OnboardingStatusWidget from '@src/App/Components/_UnderConstruction/Widgets/OnboardingStatusWidget';
import ProjectsWidget from '@src/App/Components/_UnderConstruction/Widgets/ProjectsWidget';
import RolesWidget from '@src/App/Components/_UnderConstruction/Widgets/RolesWidget';
import SkillsOverviewWidget from '@src/App/Components/_UnderConstruction/Widgets/SkillsOverviewWidget';
import NotificationWidget from '@src/App/Components/Widgets/NotificationWidget';
import React from 'react';

export default function EmployeeDashboardSection() {
    return (
        <>
            <Box sx={{ mb: 3 }}>
                <OnboardingStatusWidget />
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, mb: 3 }}>
                <Box sx={{ flex: { xs: '1 1 100%', md: '1 1 calc(50% - 12px)' } }}>
                    <NotificationWidget />
                </Box>
                <Box sx={{ flex: { xs: '1 1 100%', md: '1 1 calc(50% - 12px)' } }}>
                    <EmployeeTalksWidget />
                </Box>
            </Box>
            {/* Profile widgets hidden */}
            {/* <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, mb: 3 }}>
        <Box sx={{ flex: { xs: '1 1 100%', lg: '1 1 calc(33.333% - 16px)' } }}>
          <AvailabilityWidget />
        </Box>
        <Box sx={{ flex: { xs: '1 1 100%', lg: '1 1 calc(33.333% - 16px)' } }}>
          <SkillsOverviewWidget />
        </Box>
        <Box sx={{ flex: { xs: '1 1 100%', lg: '1 1 calc(33.333% - 16px)' } }}>
          <CertificatesWidget />
        </Box>
      </Box>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, mb: 5 }}>
        <Box sx={{ flex: { xs: '1 1 100%', lg: '1 1 calc(33.333% - 16px)' } }}>
          <ProjectsWidget />
        </Box>
        <Box sx={{ flex: { xs: '1 1 100%', lg: '1 1 calc(33.333% - 16px)' } }}>
          <GoalsWidget />
        </Box>
        <Box sx={{ flex: { xs: '1 1 100%', lg: '1 1 calc(33.333% - 16px)' } }}>
          <RolesWidget />
        </Box>
      </Box> */}
        </>
    );
}
